import React from 'react';
import styles from './color.module.css';

/**
 * A grid of colour swatches choosing one colour (`value`, or null for none). Given `none`, the first swatch is a
 * "no colour" choice (white with a red slash); `none.lockedReason` disables it and says why on hover.
 */
export const SwatchGrid = ({ label, colors, value, onChange, none }) => (
    <div className={styles.swatchGrid} role="radiogroup" aria-label={label}>
        {none && (
            <button
                type="button"
                role="radio"
                aria-checked={value === null}
                aria-label={none.label}
                title={none.lockedReason ?? none.label}
                disabled={Boolean(none.lockedReason)}
                className={`${styles.gridSwatch} ${styles.gridSwatchNone} ${value === null ? styles.gridSwatchOn : ''}`.trim()}
                onClick={() => onChange(null)}
            />
        )}
        {colors.map((color) => (
            <button
                key={color}
                type="button"
                role="radio"
                aria-checked={color === value}
                aria-label={color}
                title={color.toUpperCase()}
                className={`${styles.gridSwatch} ${color === value ? styles.gridSwatchOn : ''}`.trim()}
                style={{ '--swatch': color }}
                onClick={() => onChange(color)}
            />
        ))}
    </div>
);
